import SiderLayout from "../../layouts/SiderLayout";
import { InterpretesSlider } from "../../pages/Interpretes/InterpreteSlider/InterpretesSlider";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";

let childrenNormal = generateChildren([
  routes.interpretes().detail,
  routes.interpretes().detailSchedule,
]);

export const interpretesRouter = [
  {
    path: routes.interpretes().path,
    handle: {
      crumb: e => routes.interpretes().ressourceCrumb(e),
    },
    element: (
      <SiderLayout>
        <InterpretesSlider></InterpretesSlider>
      </SiderLayout>
    ),
    children: [
      {
        path: routes.interpretes().detail.path,
        handle: {
          crumb: e => routes.interpretes().crumb(e),
        },
        children: childrenNormal,
      },
    ],
  },
];
